import { render, staticRenderFns } from "./IvmApiView.vue?vue&type=template&id=4209ca59&lang=pug&"
import script from "./IvmApiView.vue?vue&type=script&lang=ts&"
export * from "./IvmApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports